import { render, staticRenderFns } from "./RatingSelector.vue?vue&type=template&id=582ba193&scoped=true&"
import script from "./RatingSelector.vue?vue&type=script&lang=ts&"
export * from "./RatingSelector.vue?vue&type=script&lang=ts&"
import style0 from "./RatingSelector.vue?vue&type=style&index=0&id=582ba193&prod&lang=scss&scoped=true&deep=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582ba193",
  null
  
)

export default component.exports